import script from "./guidePage.vue?vue&type=script&setup=true&lang=js"
export * from "./guidePage.vue?vue&type=script&setup=true&lang=js"

import "./guidePage.vue?vue&type=style&index=0&id=251fd501&scope=true&lang=scss"

const __exports__ = script;

export default __exports__